import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/tooltip'
import modals from './modules/modals-manager'
import locator from './modules/locator'
import header from './modules/header'
import categorySelect from './modules/category-select'
import Cart from './modules/cart'
import './plugins/contact-map'
import './plugins/side-ctas'
import './plugins/table-of-contents'
import './plugins/product-grid'
import './plugins/card-gallery'
import './modules/product'
import './modules/cart-button'
import './plugins/search-bar'
import './plugins/share'
import { Tabs, Mobile, Popup, Carousel_CoreInit, iOS, Android, Hotspot_CoreInit, Accordion, Scrollbar, Form_CoreInit } from './core'
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import Favorites from './modules/favorites'
import { createBundleDropdowns } from './modules/bundle-dropdowns'
import { carouselConfigs } from './modules/carousel-config'

$(function () {
  $.mlmi = {
    mobile: new Mobile(),
    scroll: $(window).ScrollEvents(),
    cart: undefined,
    favorites: undefined,
    history: undefined,
  }

  if (iOS() || Android()) {
    hastouch()
  }

  /* Favorites */
  Favorites.init()

  /* Tabs */
  Tabs.init({
    changeHash: false,
  })

  /* Search Bar */
  $('.search-bar').SearchBar()

  /* Product Grid */
  $('.product-list').ProductGrid()

  /* Card Gallery */
  $('.shop__products .product-list__picture--has-gallery').CardGallery()

  /* Share */
  $('.share:not(.wishlist-share)').Share()

  $('input[name="inf_field_FirstName"]').val('')
  $('input[name="inf_field_LastName"]').val('')
  $('input[name="inf_field_Email"]').val('')

  /* Prevent empty anchor clicks */
  $('a[href="#"]:not(.js-cart-button)').on('click', function() {
    if ($(this).hasClass('acf-button') || $(this).hasClass('acf-icon') || $(this).hasClass('js-cart-button')) {
      return
    }
    return false
  })

  /* Wrap error message */
  $('main.shop .woocommerce-info').wrap('<div class="container"></div>');

  //searchBar.init()
  modals.init()
  locator.init()
  header.init()
  categorySelect.init()

  /* Popup */
  Popup.init({
    click_outside: function() {
      if ($('body').hasClass('points-de-vente') || $('body').hasClass('points-of-sale')) {
        return false
      }
      return true
    }(),
  })

  /* Accordéons */
  Accordion.init();

  /* Forms */
  Form_CoreInit([
    {
      classSelector: 'builder-form',
      formOptions: {
        floating_labels: true,
      },
    },
  ])

  /* Calendrier des champs de date. Le composant de formulaire embarque sa propre
  * copie du plugin : sur une page où WordPress charge déjà jQuery UI, la copie
  * chargée en dernier remplace l'autre et les champs déjà liés perdent leur
  * calendrier. On s'en tient donc à celui que WordPress sert, déjà traduit. */
  if ($.datepicker) {
    $('.field--type-date_picker input').datepicker({
      dateFormat: 'yy-mm-dd',
      minDate: 0,
    })
  }

  /* Champs nombre des formulaires : chiffres seulement. Un caractère refusé
  * (« e », « - ») laisse la valeur vide pour le navigateur, et l'étiquette
  * flottante reste alors par-dessus le texte tapé. */
  $(document).on('keydown', '.builder-form input[type=number]', function(e) {
    if (e.key && e.key.length === 1 && !/[0-9]/.test(e.key) && !e.ctrlKey && !e.metaKey) {
      e.preventDefault()
    }
  })
  $(document).on('paste', '.builder-form input[type=number]', function(e) {
    const text = (e.originalEvent.clipboardData || window.clipboardData).getData('text')
    if (!/^[0-9]+$/.test(text.trim())) {
      e.preventDefault()
    }
  })

  //Button spacing
  $('.text-content a[class*=btn-]').each(function() {
    if ($(this).parent().is('p')) {
      if ($(this).parent().children().length === $(this).parent().find('a[class*=btn-]').length) {
        $(this).parent().contents().wrapAll('<div class="btn-wrapper"></div>');
      }
    }
  })

  /* Side CTAs */
  $('.article-single__main').each(function() {
    $(this).SideCtas($('.article-single__stage'))
  })

  $('.table-of-contents').each(function() {
    $(this).ToggleTableOfContents();
  })

  /* Scroll spy de la nav d'une section « Article hub » (plugin existant) */
  $('.article-hub .table-of-contents').each(function() {
    $(this).TableOfContents({
      scroll_events: $.mlmi.scroll,
      header_offset: function() {
        return 32 + ($('.header').outerHeight(false) || 0) + ($('.top-bar').outerHeight(false) || 0)
      },
    })
  })

  /* Products */
  $('body.single-product').each(function() {
    $(this).Product()
  })

  /* Clone product badges to galleries */
  if ($('body.single-product').length) {
    const badgeSelectors = ['.sale-flash', '.provenance-flash', '.stock-flash']
    const hasThumbnails = $('.thumbnail-gallery__thumbnails').length > 0

    badgeSelectors.forEach(function(selector) {
      const $badge = $('.single-product-page__product ' + selector)
      if ($badge.length) {
        $('.single-product-page__mobile-gallery').each(function() {
          if (!$(this).find(selector).length) {
            $(this).prepend($badge.clone())
          }
          // Add --single-image class if no thumbnails
          if (!hasThumbnails) {
            $(this).addClass('--single-image')
          }
        })
        $('.single-product-page__preview-wrapper').each(function() {
          if (!$(this).find(selector).length) {
            $(this).prepend($badge.clone())
          }
          // Add --single-image class if no thumbnails
          if (!hasThumbnails) {
            $(this).addClass('--single-image')
          }
        })
      }
    })
  }

  /* Cart */
  Cart.init()

  /* Show login box */
  $('a.showlogin').off('click').on('click', function() {
    $.fancybox.open({
      src: $('form.woocommerce-form-login'),
      type: 'inline',
    })
    return false
  })

  /* Logout link */
  $('.woocommerce-MyAccount-navigation-link--customer-logout a').attr('href', $('.account-header__intro a:first').attr('href'))

  /* Thankyou: copy promo code */
  $('.thankyou__copy').on('click', function() {
    const $btn = $(this)
    // Guard les clics rapides : sans ça le 2e clic capturerait
    // « Copié! » comme libellé et figerait le bouton.
    if ($btn.data('copying')) {
      return
    }
    const label = $btn.text()
    navigator.clipboard.writeText($btn.data('code')).then(function() {
      $btn.data('copying', true).text(gourmetsauvage_params.CODE_COPIED)
      setTimeout(function() {
        $btn.text(label).removeData('copying')
      }, 2000)
    }).catch(function() {})
  })

  /* Thankyou: demande de rappel par courriel */
  $('.thankyou__reminder-btn').on('click', function() {
    const $btn = $(this)
    if ($btn.hasClass('is-scheduled') || $btn.data('sending')) {
      return
    }
    const original = $btn.text()
    $btn.data('sending', true).addClass('loading').text(gourmetsauvage_params.REMINDER_SENDING)

    $.post(gourmetsauvage_params.ajax_url, {
      action: 'gs_coupon_reminder',
      order_id: $btn.data('order-id'),
      order_key: $btn.data('order-key')
    }).done(function(res) {
      if (res && res.success) {
        $btn.removeClass('loading').addClass('is-scheduled').prop('disabled', true).text(gourmetsauvage_params.REMINDER_SCHEDULED).removeData('sending')
      } else {
        $btn.removeClass('loading').text(original).removeData('sending')
        alert(gourmetsauvage_params.REMINDER_ERROR)
      }
    }).fail(function() {
      $btn.removeClass('loading').text(original).removeData('sending')
      alert(gourmetsauvage_params.REMINDER_ERROR)
    })
  })

  /* Demande d'avis après commande */
  const $reviewRequest = $('.review-request')
  if ($reviewRequest.length) {
    const $nameBox = $reviewRequest.find('.review-request__name')
    const $nameInput = $nameBox.find('input[name="review_name"]')

    $nameBox.on('click', '.review-request__name-edit', function() {
      $nameBox.addClass('is-editing')
      $nameInput.trigger('focus').trigger('select')
    })

    $nameInput.on('input', function() {
      $nameBox.find('.review-request__name-value').text($(this).val().trim())
    })

    $reviewRequest.on('change', '.review-request__stars input', function() {
      $(this).closest('.review-request__item').removeClass('has-error').find('.review-request__item-status').removeClass('is-success').text('')
    })

    $reviewRequest.on('submit', '.review-request__item', function(e) {
      e.preventDefault()
      const $item = $(this)
      const $button = $item.find('.review-request__submit')
      const $status = $item.find('.review-request__item-status')
      const rating = $item.find('.review-request__stars input:checked').val()

      if ($button.prop('disabled')) {
        return
      }
      if (!rating) {
        $item.addClass('has-error')
        $status.removeClass('is-success').text($reviewRequest.data('rating-required'))
        return
      }

      $button.prop('disabled', true)
      $status.removeClass('is-success').text('')

      $.post(gourmetsauvage_params.ajax_url, {
        action: 'gs_review_request_submit',
        order_key: $reviewRequest.data('order-key'),
        order_id: $reviewRequest.data('order-id'),
        gs_lang: $reviewRequest.data('lang'),
        product_id: $item.data('product-id'),
        rating: rating,
        comment: $item.find('textarea[name="comment"]').val(),
        name: $nameInput.val().trim()
      }).done(function(res) {
        if (res && res.success) {
          $item.addClass('is-done')
          $item.find('.review-request__stars, textarea, .review-request__submit').remove()
          $status.addClass('is-success').text(res.data.message)
        } else {
          $button.prop('disabled', false)
          $status.text(res && res.data && res.data.message ? res.data.message : $reviewRequest.data('error'))
        }
      }).fail(function(xhr) {
        const res = xhr.responseJSON
        $button.prop('disabled', false)
        $status.text(res && res.data && res.data.message ? res.data.message : $reviewRequest.data('error'))
      })
    })
  }

  /* Hotspot */
  Hotspot_CoreInit([
    {
      beforeOpen: function(hotspot_item) {
        var header = $('.header').outerHeight() + $('.top-bar').outerHeight() + 40;
        var scrollTop = $(window).scrollTop(),
        elementOffset = $(hotspot_item).offset().top - $(hotspot_item).find('.hotspot-item__content').outerHeight(),
        distance = (elementOffset - scrollTop);
        if (distance < header) {
          hotspot_item.addClass('--bottom')
        } else {
          hotspot_item.removeClass('--bottom')
        }

        var rightOffset = $(hotspot_item).offset().left + $(hotspot_item).find('.hotspot-item__content').outerWidth(),
        horizontal_distance = $(window).width() - rightOffset;
        if (horizontal_distance < 30) {
          hotspot_item.addClass('--left')
        } else {
          hotspot_item.removeClass('--left')
        }
      },
    },
  ]);
  $(window).on('load resize orientationchange', function() {
    $('.hotspot-item__bubble[arie-hidden="true"]').each(function() {
      var hotspot_item = $(this).closest('.hotspot-item');
      if (!hotspot_item.hasClass('--left')) {
        var rightOffset = $(hotspot_item).offset().left + $(hotspot_item).find('.hotspot-item__content').outerWidth(),
        horizontal_distance = $(window).width() - rightOffset;
        if (horizontal_distance < 30) {
          hotspot_item.addClass('--left')
        }
      }
    })
  })

  /* Quantity in cart */
  $(document.body).on('wc_fragments_loaded wc_fragments_refreshed added_to_cart', function() {
    $('.cart-panel input.qty').each(function() {
      $(this).Quantity()
    })
  })

  /* Quantity in ateliers */
  $('.single-atelier input.qty').each(function() {
    $(this).Quantity()
  })

  /* Contact map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })

  /*
  * Checkout popup
  */
  if ($('.shipping-notification--checkout').length) {
    $.fancybox.open({
      src: '.shipping-notification--checkout',
      type: 'inline',
      touch: false
    });
  }

  /*
  * Scroll to
  */
  /* Load anchors properly */

  // if (window.location.hash != '') {
  //   if ($(window.location.hash).length) {
  //     let targetTop = $(window.location.hash).offset().top - 32 - $('.header').outerHeight(false)
  //     if ($('.top-bar').length) {
  //       targetTop -= $('.top-bar').outerHeight(false)
  //     }
  //     $('body, html').scrollTo(targetTop, 500, 6, 'easeInOutQuart')
  //   }
  // }
  $('.information-produit > a').on('click', function(e) {
    e.preventDefault()
    let targetTop = $($(this).attr('href')).offset().top - 32 - $('.header').outerHeight(false) - $('.top-bar').outerHeight(false)
    $('body, html').scrollTo(targetTop, 500, 6, 'easeInOutQuart')
  })
  $('.cr-review-link').on('click', function(e) {
    e.preventDefault()
    if (!$('#product-reviews').length) return
    let targetTop = $('#product-reviews').offset().top - 32 - $('.header').outerHeight(false) - $('.top-bar').outerHeight(false)
    $('body, html').scrollTo(targetTop, 500, 6, 'easeInOutQuart')
  })
  $('.article-single__sidebar .table-of-contents a').on('click', function(e) {
    e.preventDefault()
    let targetTop = $($(this).attr('href')).offset().top - 32 - $('.header').outerHeight(false) - $('.top-bar').outerHeight(false)
    $('body, html').scrollTo(targetTop, 500, 6, 'easeInOutQuart')
  })
  $(".text-content a, .page-id-51040 main a, .main-menu__link, .page-intro__content a, .collection-hero a, .styleguide a").on('click', function(e) {
    if ($(this).attr('href') !== undefined && $(this).attr('href').substr(0, 1) == '#') {
      if ($($(this).attr('href')).length) {
        e.preventDefault()
        let targetTop = $($(this).attr('href')).offset().top - 32 - $('.header').outerHeight(false)
        if ($('.top-bar').length) {
          targetTop -= $('.top-bar').outerHeight(false)
        }
        $('body, html').scrollTo(targetTop, 500, 6, 'easeInOutQuart')
      }
    }
    if ($('.burger').attr('aria-expanded') == 'true') {
      $('.burger').click()
    }
  })

  /*
  * Table of contents
  */
  $('.article-single__sidebar').each(function() {
    let limitFromTop = 20
    if ($('.top-bar').length) {
      limitFromTop += $('.top-bar').outerHeight(false)
    }
    $(this).FixedContent({
      limitFromTop: limitFromTop,
      bottomBlocker: $('.related-articles, .footer').first(),
    })
  })

  /* Sidebar « Article hub » : même mécanique fixe que la sidebar blogue, bornée à la fin de la section */
  $('.article-hub__sidebar').each(function() {
    let $next = $(this).closest('.article-hub').parent().next()
    let limitFromTop = 20
    if ($('.top-bar').length) {
      limitFromTop += $('.top-bar').outerHeight(false)
    }
    $(this).FixedContent({
      limitFromTop: limitFromTop,
      bottomBlocker: $next.length ? $next : $('.footer').first(),
    })
  })

  /*
  * Map fixed
  */
  $('.locator-container > .row > .col:last-child > .text-content').each(function() {
    $(this).FixedContent({
      limitFromTop: function() {
        return parseInt($('html').css('--total-header-height'), 10) - $('.header').outerHeight(false)
      }(),
    })
  })

  /*
  * Shop category sidebar + settings: fixed content
  */
  let $shopCategoryWrapper = $('.shop-category-wrapper')
  if ($shopCategoryWrapper.length) {
    let limitFromTop = parseInt($('html').css('--total-header-height'), 10) - $('.header').outerHeight(false) + 20
    let $bottomBlocker = $shopCategoryWrapper.next()
    let fixedValidate = function() { return window.innerWidth < 850 }
    $shopCategoryWrapper.find('.woocommerce-products-header').FixedContent({
      limitFromTop: limitFromTop,
      bottomBlocker: $bottomBlocker,
      validate: fixedValidate,
    })
    $shopCategoryWrapper.find('.settings-trigger__container').FixedContent({
      bottomBlocker: $bottomBlocker,
      limitFromTop: limitFromTop,
      validate: fixedValidate,
    })
  }

  /* Back to top */
  $('.back-to-top').on('click', function() {
    $('html, body').scrollTo(0, 350, 4, 'easeInOutQuart')
  })
  let scrolledDown = false,
  topArrow = $('.back-to-top').BlockElement()

  /*
  * Add to cart button
  */
  $('.add_to_cart_button.ajax_add_to_cart').each(function() {
    $(this).CartButton()
  })
  $('.single-atelier form.cart, form.cart-button').each(function() {
    $(this).CartForm()
  })

  /*
  * Home carousel
  */
  $.fn.CarouselContent = function() {
    let self = this

    if (self.data('carousel-content')) {
      return self.data('carousel-content')
    }

    self.wrapper = $('<div class="carousel__content-wrapper"></div>')

    self.setContent = function(content) {
      self.find('.card-custom__content').each(function() {
        $(this).fadeOut(550, function() {
          $(this).remove()
        })
      })
      setTimeout(function() {
        content.hide()
        self.wrapper.append(content.fadeIn(350))
      }, 50)
    }

    return function() {
      self.prepend(self.wrapper)
      self.data('carousel-content', self)
      return self
    }()
  }

  /* Patch remove empty grid cells... */
  $('.grid__item').filter(function() {
    return $.trim($(this).html()) === '';
  }).remove();

  if ($('.carousel--style--default').length) {
    $('.carousel--style--default').find('.carousel__toolbar').wrap($('<div class="carousel__content"></div>'));
    let carouselContent = $('.carousel__content').CarouselContent()

    Carousel_CoreInit([
      ...carouselConfigs,
      {
        classSelector: 'carousel--style--default',
        swiperOptions: {
          speed: 500,
          breakpoints: {
            0: {
              spaceBetween: 0,
            },
            768: {
              spaceBetween: 0,
            },
          },
          on: {
            slideChangeTransitionStart: function(swiper) {
              let currentSlide = swiper.slides[swiper.activeIndex],
              slideContent = $(currentSlide).find('.card-custom__content')
              carouselContent.setContent(slideContent.clone())
            },
            beforeResize: function(swiper) {
              if (!$.mlmi.mobile.isMobile) {
                const $content = $('.carousel__content')
                if ($content.length && $content.offset()) {
                  $('.carousel--style--default').css({
                    width: 'calc(100vw - ' + Math.floor($content.offset().left) + 'px)',
                  })
                }
              }
            }
          },
        },
      }
    ])
    if (!$.mlmi.mobile.isMobile) {
      const $content = $('.carousel__content')
      if ($content.length && $content.offset()) {
        $('.carousel--style--default').css({
          width: 'calc(100vw - ' + Math.floor($content.offset().left) + 'px)',
        })
      }
    }
  } else {
    Carousel_CoreInit(carouselConfigs)
  }

  // Hero slider: parallax effect on floating images (désactivé sur appareils tactiles)
  if ($('.carousel--style--hero').length && !$('html').hasClass('has-touch')) {
    const $hero = $('.carousel--style--hero');
    const depths = [4, -3, 3];

    $hero.on('mousemove', function(e) {
      const rect = this.getBoundingClientRect();
      const mx = (e.clientX - rect.left) / rect.width - 0.5;
      const my = (e.clientY - rect.top) / rect.height - 0.5;
      const $activeSlide = $(this).find('.swiper-slide-active .card-hero__float');
      $activeSlide.each(function(i) {
        const d = depths[i] || 3;
        const baseTransform = $(this).attr('data-base-transform') || $(this).css('transform');
        if (!$(this).attr('data-base-transform')) {
          $(this).attr('data-base-transform', baseTransform === 'none' ? '' : baseTransform);
        }
        $(this).css('transform', $(this).attr('data-base-transform') + ' translate(' + (mx * d) + 'px, ' + (my * d) + 'px)');
      });
    });

    $hero.on('mouseleave', function() {
      $(this).find('.card-hero__float').each(function() {
        if ($(this).attr('data-base-transform')) {
          $(this).css('transform', $(this).attr('data-base-transform'));
        }
      });
    });
  }

  /* Reels: Vimeo lightbox — reuses the product-gallery interface (pale bg, arrows,
   * product info + real ajax add-to-cart inside the lightbox) */
  if ($('.carousel--style--reels').length) {
    // Le panneau produits vit dans le stage, à droite de la vidéo en desktop et sous
    // elle en mobile. Fancybox centre le stage par `vertical-align` sur un élément
    // inline : le CSS le met en `inline-flex`, un `flex` bloc casserait le centrage.
    function injectReelsPanel(slide) {
      if (!slide || !slide.$slide) return
      var html = slide.opts && slide.opts.reelsPanel
      if (!html || !html.trim()) return
      var $stage = slide.$slide.find('.reels-lightbox__stage')
      if (!$stage.length || $stage.find('.reels-panel').length) return

      var $panel = $(html)
      $stage.append($panel)
      initReelsBundleDropdowns($panel)
      initReelsVariationSelects($panel)
      bindReelsCartButtons($panel)

      // La largeur de la vidéo n'est connue qu'une fois ses métadonnées lues
      syncReelsPanelWidth($panel)
      $stage.find('.reels-lightbox__video').on('loadedmetadata.reelsPanel', function() {
        syncReelsPanelWidth($panel)
      })

      // Déroulant : le dégradé du bas ne s'affiche que tant qu'il reste à faire défiler
      var $list = $panel.find('.reels-panel__list')
      var listEl = $list.get(0)
      if (!listEl) return
      function updateFade() {
        var more = listEl.scrollHeight - listEl.scrollTop - listEl.clientHeight > 8
        $panel.toggleClass('reels-panel--scrollable', more)
      }
      updateFade()
      $list.on('scroll', updateFade)
      $(window).on('resize.reelsPanel', function() {
        syncReelsPanelWidth($panel)
        updateFade()
      })
    }

    // Ensemble à composante optionnelle : le même menu déroulant que la carte wishlist
    // (template « simple » de createBundleDropdowns), branché sur les cases cachées que
    // CartButton relit au moment de l'ajout. Le prix affiché suit le choix, en reprenant
    // le HTML rendu par wc_price plutôt qu'en reformatant la devise ici.
    function initReelsBundleDropdowns($panel) {
      $panel.find('.reels-panel__bundle-data').each(function() {
        var $bundleData = $(this)
        var $card = $bundleData.closest('.reels-panel__card')
        var $dataScript = $card.find('.bundle-custom-data')
        if (!$dataScript.length) return

        var customData = JSON.parse($dataScript.text())
        window.bundleCustomData = customData

        var $price = $card.find('.reels-panel__price')
        var basePriceHtml = $price.attr('data-base-price-html')

        function updatePrice() {
          var $checked = $bundleData.find('input.bundled_product_checkbox:checked')
          var html = basePriceHtml
          $checked.each(function() {
            var itemId = $(this).attr('name').replace('bundle_selected_optional_', '')
            if (customData[itemId] && customData[itemId].price_html) {
              html = customData[itemId].price_html
            }
          })
          $price.html(html)
        }

        var $target = $('<div class="reels-panel__bundle-dropdowns"></div>')
        $card.find('.reels-panel__cardbtn').before($target)
        createBundleDropdowns($bundleData, $target, {
          mode: 'append',
          htmlTemplate: 'simple',
          onCheckboxChange: updatePrice,
        })
        updatePrice()
      })
    }

    // En desktop le panneau prend la largeur de la vidéo, pour que le bouton d'ajout
    // reste au large une fois le spinner ou le crochet posé par les états loading/added.
    // La largeur se mesure plutôt que de se fixer en CSS : la vidéo garde son ratio réel,
    // vertical comme paysage. On la plafonne pour que la paire tienne dans l'écran.
    function syncReelsPanelWidth($panel) {
      var $stage = $panel.closest('.reels-lightbox__stage')
      var video = $stage.find('.reels-lightbox__video').get(0)
      if (!video || !window.matchMedia('(min-width: 992px)').matches) {
        $panel.css('width', '').removeClass('reels-panel--narrow')
        return
      }
      var videoWidth = video.getBoundingClientRect().width
      if (!videoWidth) return
      var available = window.innerWidth - videoWidth - 92
      var width = Math.round(Math.max(Math.min(videoWidth, available), 240))
      $panel.css('width', width + 'px')
      // Sous ce seuil, la quantité et le bouton ne tiennent plus sur une rangée : le
      // bouton se ferait tronquer, puisqu'il ne revient pas à la ligne.
      $panel.toggleClass('reels-panel--narrow', width < 360)
    }

    // Produit à variations : mêmes menus déroulants que la carte wishlist. Le bouton
    // porte la variation retenue via data-variation-id, que CartButton relit à l'ajout ;
    // sans choix complet, CartButton refuse et ouvre sa pop-up.
    function initReelsVariationSelects($panel) {
      $panel.find('.reels-panel__variations').each(function() {
        var $variations = $(this)
        var $card = $variations.closest('.reels-panel__card')
        var $dataScript = $card.find('.variations-data')
        if (!$dataScript.length) return

        var variationsData = JSON.parse($dataScript.text())
        var $selects = $variations.find('select')
        var $button = $card.find('.add_to_cart_button')
        var $price = $card.find('.reels-panel__price')
        var basePriceHtml = $price.attr('data-base-price-html')

        $selects.on('change', function() {
          var selected = {}
          var allSelected = true
          $selects.each(function() {
            var value = $(this).val()
            if (!value) { allSelected = false; return }
            selected['attribute_' + $(this).data('attribute-name')] = value.toLowerCase()
          })

          if (!allSelected) {
            $button.data('variation-id', 0).attr('data-variation-id', 0)
            $price.html(basePriceHtml)
            return
          }

          var match = variationsData.find(function(variation) {
            return Object.keys(selected).every(function(attr) {
              var value = variation.attributes[attr] ? variation.attributes[attr].toLowerCase() : ''
              return value === selected[attr]
            })
          })
          if (!match) return

          $button.data('variation-id', match.variation_id).attr('data-variation-id', match.variation_id)
          if (match.gs_price_html) $price.html(match.gs_price_html)
        })
      })
    }

    // CartButton pose `self = this` sur la collection reçue : branché d'un coup, un seul
    // clic ferait tourner toutes les cartes et n'enverrait qu'un produit. Un bouton à la
    // fois, et une seule fois — afterShow retourne à chaque changement de slide.
    function bindReelsCartButtons($scope) {
      if (!$.fn.CartButton) return
      $scope.find('.add_to_cart_button.ajax_add_to_cart').each(function() {
        var $button = $(this)
        if ($button.data('reelsCartBound')) return
        $button.data('reelsCartBound', true)
        $button.CartButton()
      })
    }

    function openReelsLightbox($clicked) {
      // Exclude Swiper loop duplicates to avoid duplicate gallery entries
      var $allVideos = $('.card-reels--has-video').filter(function() {
        return !$(this).closest('.swiper-slide-duplicate').length
      })
      var items = []
      $allVideos.each(function() {
        var videoSrc = $(this).data('video-src')
        if (!videoSrc) return
        var videoType = $(this).data('video-type')
        var $content = $(this).find('.card-reels__lightbox-content')
        var caption = $content.length ? $content.html() : ''
        // Sans produit ni CTA custom, pas de panneau : le reel prend toute la hauteur.
        var fullClass = (caption && caption.trim()) ? '' : 'reels-lb--full'
        if (videoType === 'video') {
          // MP4 hébergé : <video> emballé dans un <div> pour que fancybox garde le type
          // « html » (un <video> nu bascule en contentType=video + taille 640x360 16:9).
          // Le panneau produits voyage dans `reelsPanel` et non dans `caption` : il est
          // injecté dans le stage à afterShow, à côté de la vidéo, pas dans la barre du bas.
          items.push({
            type: 'html',
            src: '<div class="reels-lightbox__stage"><video class="reels-lightbox__video" src="' + videoSrc + '" controls autoplay loop playsinline preload="auto" controlsList="nodownload"></video></div>',
            opts: { reelsPanel: caption, slideClass: fullClass },
          })
        } else {
          // Vimeo : iframe player
          items.push({
            src: videoSrc,
            type: 'iframe',
            opts: {
              caption: caption,
              slideClass: fullClass,
              iframe: {
                attr: {
                  allow: 'autoplay; fullscreen; picture-in-picture',
                  allowfullscreen: true,
                },
              },
            },
          })
        }
      })
      // If clicked slide is a loop duplicate, resolve to the original
      var $target = $clicked
      if ($clicked.closest('.swiper-slide-duplicate').length) {
        var realIndex = $clicked.closest('.swiper-slide').attr('data-swiper-slide-index')
        $target = $('.swiper-slide[data-swiper-slide-index="' + realIndex + '"]')
          .not('.swiper-slide-duplicate')
          .find('.card-reels--has-video')
      }
      var startIndex = $allVideos.index($target)
      if (startIndex < 0) startIndex = 0
      $.fancybox.open(items, {
        loop: true,
        // CAUSE du « skip » : Fancybox v3 (video.autoStart, défaut true) démarre la 1re
        // vidéo et lie `ended → self.next()` — à la fin d'un reel, la galerie saute au
        // suivant. L'attribut <video loop> ne suffit pas à empêcher `ended` (Safari/iOS et
        // un MP4 streamé l'émettent quand même). On coupe l'auto-démarrage de Fancybox ;
        // c'est notre afterShow qui joue le reel courant.
        video: { autoStart: false },
        // Fancybox masque les flèches prev/next après `idleTime` secondes sans bouger
        // la souris : on désactive pour qu'elles restent visibles en tout temps.
        idleTime: false,
        infobar: false,
        zoom: false,
        baseClass: '--product-gallery --reels',
        btnTpl: {
          arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
          + '<i class="icon-chevron-up"></i>'
          + '</button>',
          arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
          + '<i class="icon-chevron-up"></i>'
          + '</button>',
        },
        buttons: ['close'],
        smallBtn: false, // pas de × sur la vidéo : on garde le close de la toolbar (coin haut-droit du conteneur)
        afterClose: function() {
          $(window).off('.reelsPanel')
        },
        // Le panneau se bâtit au chargement du contenu, pas à son affichage : afterLoad
        // s'exécute dans le même tick que le changement de slide, donc le panneau est en
        // place avant le rendu au lieu de s'ajouter après coup. Fancybox ne précharge pas
        // les slides de type « html » et vide les voisins à chaque bascule : il n'y a rien
        // à préparer d'avance, seulement à cesser d'arriver en retard.
        afterLoad: function(instance, slide) {
          injectReelsPanel(slide)
        },
        afterShow: function(instance, current) {
          injectReelsPanel(current)
          // La vidéo d'un slide préchargé n'a pas encore de largeur mesurable
          syncReelsPanelWidth(current.$slide.find('.reels-panel'))
          bindReelsCartButtons(instance.$refs.container)
          // Une seule vidéo joue à la fois : le slide courant. Fancybox précharge les
          // slides adjacents (chacun un <video autoplay>) ; on met en pause + on rembobine
          // tout sauf le slide courant pour éviter la lecture en arrière-plan.
          $.each(instance.slides, function(i, slide) {
            var v = slide.$slide && slide.$slide.find('video').get(0)
            if (!v) return
            if (slide.index === current.index) {
              try { v.play() } catch (e) {}
            } else {
              try { v.pause(); v.currentTime = 0 } catch (e) {}
            }
          })
        },
      }, startIndex)
    }

    // The reels carousel auto-scrolls continuously, so a native `click` (which needs
    // mousedown + mouseup on the SAME element) is frequently lost as the card slides
    // under the pointer — and on touch there's no hover to freeze it. Detect the tap
    // ourselves: capture the pressed card on pointerdown (immune to it moving), then
    // open on pointerup as long as the pointer barely moved (i.e. a tap, not a scroll).
    var reelsPress = null
    var REELS_TAP_SLOP = 12

    $(document).on('pointerdown', '.card-reels--has-video', function(e) {
      reelsPress = { card: $(this), x: e.clientX, y: e.clientY, t: Date.now() }
    })

    $(document).on('pointerup', function(e) {
      if (!reelsPress) return
      var moved = Math.abs(e.clientX - reelsPress.x) + Math.abs(e.clientY - reelsPress.y)
      var elapsed = Date.now() - reelsPress.t
      var $card = reelsPress.card
      reelsPress = null
      if (moved <= REELS_TAP_SLOP && elapsed < 700 && $card && $card.length) {
        e.preventDefault()
        openReelsLightbox($card)
      }
    })

    // Drop a stale press if the gesture is cancelled
    $(document).on('pointercancel', function() { reelsPress = null })
  }

  $(window).on('load resize orientationchange', function() {
    $('.embed-container').css('--video-height', function() {
      return (($(this).find('iframe').attr('height') / $(this).find('iframe').attr('width')) * $(this).width()) + 'px';
    })
  })

  /* Scroll events */
  $.mlmi.scroll.add(function(top) {
    /* Back to top */
    if (!scrolledDown && top > $(window).height() / 2) {
      scrolledDown = true
      topArrow.addModifier('visible')
      $('body').addClass('--scroll-top-visible')
    } else if (scrolledDown && top < $(window).height() / 2) {
      scrolledDown = false
      topArrow.removeModifier('visible')
      $('body').removeClass('--scroll-top-visible')
    }

    /* Picture this (blur) */
    $('.blur-in').each(function() {
      let image = $(this).find('img')
      let position = $(this).offset().top - top - $(window).height() - $('.header').outerHeight()
      if ($('.top-bar').length) {
        position -= $('.top-bar').outerHeight()
      }
      if (!image.data('unblur') && position < -$(window).height() * .25) {
        image.data('unblur', true)
        if (image.data('loaded')) {
          setTimeout(function() {
            picture(image.get(0))
          }, 150)
        } else {
          image.on('load', function() {
            picture(image.get(0))
          })
        }
      }
    })

    /* Background position */
    if ($('.workshop__cta').length) {
      if ($.mlmi.mobile.isMobile) {
        $('.workshop__cta').css({
          'background-position': '',
        })
      } else {
        let start = $('.workshop__cta').offset().top - $(window).height(),
        end = start + $(window).height() + $('.workshop__cta').outerHeight(false),
        scrollmax = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - $(window).height()
        if (end > scrollmax) {
          end = scrollmax
        }
        if (top >= start && top <= end) {
          let percentage = (top - start) / (end - start),
          target = $('.workshop__cta').offset().top - top - ($('.workshop__cta').outerHeight(false) * .2 * percentage)
          $('.workshop__cta').css({
            'background-position': `0px ${target}px`,
          })
        }
      }
    }

    /* Half content */
    let backgroundHeight = $('.intro-content').outerHeight(false) + (parseInt($('.half-content').css('padding-top'), 10) * 1.75)
    if ($.mlmi.mobile.isMobile) {
      backgroundHeight += $('.half-content__figure').outerHeight(false) * .4
    }
    $('.half-content__background').css({
      height: `${backgroundHeight}px`,
    })

    /* Resizer content */
    function resizerContent() {
      if ($.mlmi.mobile.isMobile) {
        $('.title-content').css('margin-bottom', '')
      } else {
        $('.title-content').css('margin-bottom', $('.title-content__figcaption').outerHeight(false))
      }

      let headerHeight = $('.header').outerHeight(false),
      tocHeight = 0
      if ($('body').hasClass('--top-bar-active')) {
        $('.header').css('top', $('.top-bar').outerHeight(false) + 'px')
        headerHeight += $('.top-bar').outerHeight(false)
      }
      if ($('.product-bar .cart-panel__message').length) {
        $('.product-bar__header').css({
          'paddingTop': $('.product-bar .cart-panel__message').outerHeight(false) + 'px',
        })
      }
      $('html').css('--header-height', Math.floor(headerHeight) + 'px')
      $('html').css('--total-header-height', Math.floor(headerHeight + tocHeight) + 'px')
    }
    $(window).on('load resize orientationchange', resizerContent)
    resizerContent()

    /* Tooltip */
    $('.badge.badge-secondary.badge-rounded').tooltip()

    /* Breadcrumb */
    const $breadcrumb = $('.breadcrumb')
    if ($breadcrumb.length) {
      $breadcrumb.on('scroll', function() {
        const scrollLeft = $(this).scrollLeft()
        const $container = $('.breadcrumb__container')

        if (scrollLeft === 0) {
          $container.removeClass('scrolled')
        } else {
          $container.addClass('scrolled')
        }
      })
    }
  })

  /*
  * Fix gift card "Send as gift" checkbox toggle
  */
  const $checkbox = $('label[for="wc_gc_send_as_gift_checkbox"]'),
  $gc_form = $('.woocommerce_gc_giftcard_form_wrapper')
  $checkbox.on('click', function(e) {
    e.preventDefault()
    if ($checkbox.find('input').prop('checked')) {
      $checkbox.find('input').prop('checked', false).trigger('change')
      $gc_form.slideUp()
    } else {
      $checkbox.find('input').prop('checked', true).trigger('change')
      $gc_form.slideDown()
    }
  })
})
